import { Injectable } from '@angular/core';

export class Settings{
  production: boolean;
  enableDevTools: boolean;
  
  backendUrlMasterData: string;
  backendUrlCKT: string;
  backendUrlReporting: string;
  backendUrlSubmission: string;
  backendUrlPolicyService: string;
  backendUrlTokenManagerService: string;

  policyServiceAppName: string;
  policyServiceAppId: number;

  ukHmrcAuthEndpoint: string;
  ukHmrcAuthClientId: string;
  ukHmrcAuthScope: string;

  analyticsScriptSrc: string;
  enableAnalytics: boolean;
  
  constructor(){}
}

@Injectable()
export class ApplicationSettings extends Settings {
  constructor(){
    super();
  }

  getLocale(){
    return "nl-BE"; //This should be configurable later
  }

  loadConfiguration(json: any) : ApplicationSettings {
 
    for (const key in json) {

      if (json.hasOwnProperty(key)) {
        this[key] = json[key];
      }
    }

    return this;
  }
}
